import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ReactNode, useCallback } from 'react';

import useIsWiderThan from '@/hooks/useIsWiderThan';
import { useAppDispatch } from '@/redux/hooks';
import { submitUnfollowSeller } from '@/redux/modules/followSeller';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';

type Props = {
    browser?: ReactNode;
    className?: string;
    email?: ReactNode;
    frequency?: ReactNode;
    sellerId?: number;
    sms?: ReactNode;
    type?: ReactNode;
};

export const TableRow = ({ browser, className, email, frequency, sellerId, sms, type }: Props) => {
    const dispatch = useAppDispatch();
    const {
        breakpoints: { xsMaxValue },
    } = mergedCaterwaulAndHammerUIThemes;
    const isMobile = !useIsWiderThan(xsMaxValue);

    const unfollowSeller = useCallback(() => {
        dispatch(submitUnfollowSeller(sellerId));
    }, [dispatch, sellerId]);

    const checkboxColumnClassName = isMobile ? 'w-1/2' : 'w-1/3';
    // the label negative margin is to adjust according to the checkbox using a grid to position its elements,
    // and it has extra space on the right if you don't have a label for the checkbox. And this forces the position
    // to be not off-center.
    const checkboxContainerClassName = 'mx-auto w-fit [&>label]:mr-[-12px]';

    return (
        <div className={cn('flex gap-md border-b border-border-secondary p-sm', className)}>
            <div
                className={cn('flex w-3/4 items-center justify-between gap-sm', {
                    'w-3/5': isMobile,
                })}
            >
                <div
                    className={cn('w-2/3', {
                        'w-full': isMobile,
                    })}
                >
                    {type}
                </div>
                {frequency && !isMobile && <div className="w-1/3">{frequency}</div>}
            </div>

            <div
                className={cn('flex w-1/4 items-center', {
                    'w-2/5': isMobile,
                })}
            >
                <div className={checkboxColumnClassName}>
                    <div className={checkboxContainerClassName}>{sms}</div>
                </div>
                <div className={checkboxColumnClassName}>
                    <div
                        className={cn(checkboxContainerClassName, {
                            // We use hidden to enforce the column coun for all rows
                            hidden: !browser || isMobile,
                        })}
                    >
                        {browser}
                    </div>
                </div>
                <div
                    className={checkboxColumnClassName}
                    onClick={unfollowSeller}
                >
                    <div className={checkboxContainerClassName}>{email}</div>
                </div>
            </div>
        </div>
    );
};
